import { render, staticRenderFns } from "./TestBox.vue?vue&type=template&id=18024588&"
import script from "./TestBox.vue?vue&type=script&lang=js&"
export * from "./TestBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports